import { MaterialDesignContent, SnackbarProvider, closeSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from '@mui/material';
import { MsalProvider } from '@azure/msal-react';
import AuthProvider from './context/AuthProvider';
import WorkflowProvider from './contexts/WorkflowProvider';
import Router from './utils/Routes';
import ChatGPTProvider from './context/ChatGPTProvider';
import { DuckDBProvider } from './contexts/DuckDBContext';
import { msalInstance } from './auth/msalInstance';
import AzureSsoCallback from './auth/AzureSsoCallback';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  // '&.notistack-MuiContent-success': {
  //   backgroundColor: '#EDF7ED',
  //   color: '#517152',
  // },
  // '&.notistack-MuiContent-error': {
  //   backgroundColor: '#fdeded',
  //   color: '#D94B4B',
  // },
  // '&.notistack-MuiContent-warning': {
  //   backgroundColor: '#FFF4E5',
  //   color: '#663C00',
  // },
}));

function App() {
  return (
    <DuckDBProvider>
      <AuthProvider>
        <MsalProvider instance={msalInstance}>
          <WorkflowProvider>
            <ChatGPTProvider>
              <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                autoHideDuration={3000}
                Components={{
                  success: StyledMaterialDesignContent,
                  error: StyledMaterialDesignContent,
                  warning: StyledMaterialDesignContent,
                }}
                iconVariant={{
                  error: <ErrorOutlineIcon sx={{ marginRight: 1, marginLeft: 0 }} />,
                }}
                action={(snackbarId) => (
                  <>
                    <IconButton
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={() => closeSnackbar(snackbarId)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </>
                )}
              >
                <AzureSsoCallback />
                <Router />
              </SnackbarProvider>
            </ChatGPTProvider>
          </WorkflowProvider>
        </MsalProvider>
      </AuthProvider>
    </DuckDBProvider>
  );
}

export default App;
